module.exports = __webpack_public_path__ + "img/card-payment.fe6ccb93.png";